<template>
  <!-- The dialog grid adds 1rem; the negative bottom margin leaves 12px below the art. -->
  <div
    class="dialog-illustration tw:relative tw:grid tw:place-items-center tw:overflow-hidden tw:mt-5.5 tw:mx-0 tw:-mb-1 tw:rounded-(--radius-card-navigation)"
    :style="{ background }"
  >
    <img class="tw:h-auto" :src="src" :style="{ width }" alt="" />
    <slot />
  </div>
</template>
<script setup>
// 1. Import necessary components
// 2. Use
defineProps({
  src: { type: String, required: true },
  background: { type: String, required: true },
  width: { type: String, default: '100%' },
});
// 3. Define a reactive variable
// 4. Define methods or computed properties if needed
// 5. VueJS Hooks
</script>
